import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";

import { DirectionEnum, ICourseDto } from "@ryde/shared";

import { IRenderColumnTemplate } from "../_core";
import { FramerTooltip } from "../../../common";
import {
  CourseScheduleCellRow,
  CourseScheduleCellWrapperStyled,
  useCourseScheduleCell,
} from "./parts";

export const CourseScheduleCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  formAttributes,
  e2eData,
  rowOriginal,
}) => {
  const displayValues = useCourseScheduleCell(value, formAttributes);
  const courseDirectionTemplate = (rowOriginal as ICourseDto | undefined)
    ?.metadata?.direction as DirectionEnum | undefined;
  const stationsInfo = (rowOriginal as ICourseDto | undefined)?.metadata
    ?.stationsInfo;

  return (
    <CourseScheduleCellWrapperStyled data-e2e-custom={e2eData}>
      <div className="course-schedule-cell__list">
        {displayValues.map((schedule, index) => (
          <FramerTooltip
            key={`${schedule.time}-${schedule.direction}-${index}`}
            content={schedule.dayTypeNames?.display}
            placement={PopoverPlacement.bottom}
          >
            <CourseScheduleCellRow
              schedule={schedule}
              courseDirectionTemplate={courseDirectionTemplate}
              stationsInfo={stationsInfo}
            />
          </FramerTooltip>
        ))}
      </div>
    </CourseScheduleCellWrapperStyled>
  );
};
